// extracted by mini-css-extract-plugin
module.exports = {"faq":"Faq_faq__4RdLk","wrapper":"Faq_wrapper__2LgeB","header":"Faq_header__qQ5tE","list":"Faq_list__V6_FG"};